import Service, {
  ServiceCreator,
  ServiceDeleter,
  ServiceReader,
  ServiceUpdater,
} from "../..";
import {
  TransmedProofInput,
  TransmedProofValidationInput,
} from "../../../dtos/transmed/process/proof";
import TransmedParticipationApi from "../../../api/transmed/participation";

class TransmedProofServiceReader extends ServiceReader {
  //   public async status(): Promise<TransmedProofUnvalidated[]> {
  //     const raw = await this.api.get(new RequestProofStatus());
  //     if (!Array.isArray(raw))
  //       throw new TypeError(
  //         "TransmedProofUnvalidated entry list is not an array."
  //       );
  //     return await Promise.all(
  //       raw.map(async (value) => await transform(TransmedProofUnvalidated)(value))
  //     );
  //   }
  //   public async participants(): Promise<OutputTransmedRegistrationPart[]> {
  //     const raw = await this.api.get();
  //     if (!Array.isArray(raw))
  //       throw new TypeError(
  //         "OutputTransmedRegistrationPart entry list is not an array."
  //       );
  //     return await Promise.all(
  //       raw.map(
  //         async (value) => await transform(OutputTransmedRegistrationPart)(value)
  //       )
  //     );
  //   }
}

class TransmedProofServiceCreator extends ServiceCreator {
  public async uploadDocuments(
    participationProof1: File | null,
    participationProof2: File | null,
    participationProof3: File | null,
    participationProof4: File | null,
    participationProof5: File | null,
    certificateText: string,
    review: string
  ): Promise<void> {
    await new TransmedParticipationApi().post(
      new TransmedProofInput(
        participationProof1,
        participationProof2,
        participationProof3,
        participationProof4,
        participationProof5,
        certificateText,
        review
      )
    );
  }

  //   public async bulkUpload(data: TransmedCertificateBulkInput): Promise<void> {
  //     await this.api.post(data, new RequestTransmedCertificateBulkUpload());
  //   }
}
class TransmedProofServiceUpdater extends ServiceUpdater {
  async accept(id: number): Promise<void> {
    return await new TransmedParticipationApi().put(
      `${id}`,
      new TransmedProofValidationInput()
    );
  }
  async reject(id: number, message: string): Promise<void> {
    return await new TransmedParticipationApi().put(
      `${id}`,
      new TransmedProofValidationInput(message)
    );
  }
}
class TransmedProofServiceDeleter extends ServiceDeleter {}

export default class TransmedProofService extends Service {
  public get read(): TransmedProofServiceReader {
    return new TransmedProofServiceReader();
  }
  public get create(): TransmedProofServiceCreator {
    return new TransmedProofServiceCreator();
  }
  public get update(): TransmedProofServiceUpdater {
    return new TransmedProofServiceUpdater();
  }
  public get delete(): TransmedProofServiceDeleter {
    return new TransmedProofServiceDeleter();
  }
}
